import { Component, OnInit } from '@angular/core';
import { CountrydetailpageService } from './countrydetailpage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CountryDetailHeroComponent } from './country-detail-hero/country-detail-hero.component';
import { CountryDetailFeaturesComponent } from './country-detail-features/country-detail-features.component';
import { CountryDetailOtherFeaturesComponent } from './country-detail-other-features/country-detail-other-features.component';
import { CountryDetailOtherCountriesComponent } from './country-detail-other-countries/country-detail-other-countries.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { MetaService } from 'src/app/shared/services/meta.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-country-detail',
  templateUrl: './country-detail.component.html',
  styleUrls: ['./country-detail.component.scss'],
  imports: [
    CountryDetailHeroComponent,
    CountryDetailFeaturesComponent,
    CountryDetailOtherFeaturesComponent,
    CountryDetailOtherCountriesComponent,
    CommonGetstartedComponent,
  ],
})
export class CountryDetailComponent implements OnInit {
  getStartedData:any;
  pageData:any;
  constructor(
    private countryDetailPageService: CountrydetailpageService,
    private activeRoute: ActivatedRoute,
    private canonical: CanonicalService,
    private meta: MetaService,
    private router: Router,
    private posthogService: PosthogService
  ) {}

  async ngOnInit(): Promise<void> {
    this.activeRoute.params.subscribe(async param => {
      if (
        param?.['countryname'] === 'Venezuela' ||
        param?.['countryname'] === 'Ukraine'
      ) {
        this.router.navigate(['/404']);
      } 
    });
    const detail = this.activeRoute.snapshot.paramMap.get('continent') + '/' + this.activeRoute.snapshot.paramMap.get('countryname');
    // this.countryDetailPageService.getCountryCurrencyDetailByIDData(detail);
    const fetchedData = await this.countryDetailPageService.getAllCountryDetail();
    if (!fetchedData || !Array.isArray(fetchedData)) return;
    this.pageData = fetchedData.filter(el => el?.fields?.id?.toLowerCase() === detail?.toLowerCase())[0]?.fields;
    this.meta.updateMeta(this.pageData?.seoMetadataReference?.fields);
    const _getData = this.pageData?.getStartedContentPanel?.fields;
    if (_getData != null) {
      this.getStartedData = {
        header: _getData.title,
        button1: {
          url: _getData?.buttons?.[0]?.fields.redirectLink,
          text: _getData?.buttons?.[0]?.fields.buttonText,
          target: _getData?.buttons?.[0]?.fields.actionType,
        },
        button2: {
          url: _getData?.buttons?.[1]?.fields.redirectLink,
          text: _getData?.buttons?.[1]?.fields.buttonText,
          target: _getData?.buttons?.[1]?.fields.actionType,
        },
      };
    }
    this.canonical.setCanonicalURL();
    const countryname = this.activeRoute.snapshot.paramMap.get('countryname');
    if (countryname) {
      this.posthogService.capturePageViewEvent(countryname);
    }
  }
}
